import { type EmbedDeploymentSettings } from "@nexus/types"
import { DEFAULT_EMBED_SETTINGS, embedVoiceSettingsFillFor } from "@nexus/types/domain"

/**
 * Merge incomplete deployment settings with defaults
 *
 * Handles legacy deployments created before full schema was enforced.
 * Ensures all views have complete data structure to work with.
 *
 * @param settings - Unknown settings from database (unvalidated)
 * @returns Complete settings with defaults filled in
 */
export function mergeEmbedDefaults(settings: unknown): EmbedDeploymentSettings {
  // Parse unknown data - handles both incomplete and complete structures
  const partial = (
    typeof settings === "object" && settings !== null ? settings : {}
  ) as Partial<EmbedDeploymentSettings>
  return {
    embedSettings: {
      ...DEFAULT_EMBED_SETTINGS.embedSettings,
      ...partial.embedSettings
    },
    securitySettings: {
      ...DEFAULT_EMBED_SETTINGS.securitySettings,
      ...partial.securitySettings
    },
    assistantSettings: {
      ...DEFAULT_EMBED_SETTINGS.assistantSettings,
      ...partial.assistantSettings
    },
    advancedSettings: {
      ...DEFAULT_EMBED_SETTINGS.advancedSettings,
      ...partial.advancedSettings
    },
    // Voice (the "call the agent" feature). Without this the form seed dropped
    // voiceSettings on every (re)load, resetting the toggle after Save. A stored
    // config is never handed a Gemini model it did not name — see the fill.
    voiceSettings: {
      ...embedVoiceSettingsFillFor(partial.voiceSettings),
      ...partial.voiceSettings
    }
  }
}
